export interface Payment {
  id: number;
  radioName: string;
  frequency: string;
  planName: string;
  amount: number;
  method: 'stripe' | 'paypal' | 'square' | 'manual';
  status: 'paid' | 'pending' | 'failed' | 'refunded' | 'manual_review' | 'cancelled';
  reviewed: boolean;
  date: string;
  reference: string;
  customerEmail?: string;
  description?: string;
  invoiceId?: string;
  contractId?: string;
  annualLicense?: string;
  extras?: string[];
  processor?: string;
}

export const methodLabels: Record<Payment['method'], string> = {
  stripe: 'Stripe',
  paypal: 'PayPal',
  square: 'Square',
  manual: 'Manual',
};

export const paymentStatusLabels: Record<Payment['status'], string> = {
  paid: 'Pagado',
  pending: 'Pendiente',
  failed: 'Fallido',
  refunded: 'Reembolsado',
  manual_review: 'Revisión Manual',
  cancelled: 'Cancelado',
};

export const paymentStatusColors: Record<Payment['status'], string> = {
  paid: 'bg-emerald-50 text-emerald-600',
  pending: 'bg-amber-50 text-amber-600',
  failed: 'bg-red-50 text-red-500',
  refunded: 'bg-sky-50 text-sky-600',
  manual_review: 'bg-violet-50 text-violet-600',
  cancelled: 'bg-foreground-100 text-foreground-500',
};

export const payments: Payment[] = [
  {
    id: 1,
    radioName: 'Radio Nueva Actitud',
    frequency: '87.90 RFW',
    planName: 'Premium',
    amount: 49.00,
    method: 'stripe',
    status: 'paid',
    reviewed: true,
    date: '2026-06-01',
    reference: 'PAY-20260601-001',
    customerEmail: 'admin@nuevaactitud.com',
    description: 'Suscripción mensual Premium — Junio 2026',
    invoiceId: 'INV-202606-001',
    contractId: 'CTR-2026-001',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'App Móvil'],
    processor: 'Stripe Connect',
  },
  {
    id: 2,
    radioName: 'Stereo Visión',
    frequency: '94.70 RFW',
    planName: 'Premium',
    amount: 49.00,
    method: 'paypal',
    status: 'paid',
    reviewed: true,
    date: '2026-06-01',
    reference: 'PAY-20260601-002',
    customerEmail: 'admin@stereovision.com',
    description: 'Suscripción mensual Premium — Junio 2026',
    invoiceId: 'INV-202606-002',
    contractId: 'CTR-2026-002',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'CDN Premium', 'Soporte VIP 24/7'],
    processor: 'PayPal Business',
  },
  {
    id: 3,
    radioName: 'TechBeats',
    frequency: '88.50 RFW',
    planName: 'Pro',
    amount: 19.00,
    method: 'stripe',
    status: 'paid',
    reviewed: false,
    date: '2026-06-02',
    reference: 'PAY-20260602-003',
    customerEmail: 'admin@techbeats.com',
    description: 'Suscripción mensual Pro — Junio 2026',
    invoiceId: 'INV-202606-003',
    contractId: 'CTR-2026-003',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['App Móvil'],
    processor: 'Stripe Connect',
  },
  {
    id: 4,
    radioName: 'Radio Élite Digital',
    frequency: '91.30 RFW',
    planName: 'Business',
    amount: 39.00,
    method: 'square',
    status: 'paid',
    reviewed: true,
    date: '2026-06-02',
    reference: 'PAY-20260602-004',
    customerEmail: 'admin@elitedigital.com',
    description: 'Suscripción mensual Business — Junio 2026',
    invoiceId: 'INV-202606-004',
    contractId: 'CTR-2026-004',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'App Móvil', 'CDN Premium'],
    processor: 'Square POS',
  },
  {
    id: 5,
    radioName: 'Radio Deportiva Total',
    frequency: '101.70 RFW',
    planName: 'Pro',
    amount: 19.00,
    method: 'stripe',
    status: 'paid',
    reviewed: false,
    date: '2026-06-03',
    reference: 'PAY-20260603-005',
    customerEmail: 'admin@deportivatotal.com',
    description: 'Suscripción mensual Pro — Junio 2026',
    invoiceId: 'INV-202606-005',
    contractId: 'CTR-2026-005',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: [],
    processor: 'Stripe Connect',
  },
  {
    id: 6,
    radioName: 'Radio Urbana 101',
    frequency: '103.50 RFW',
    planName: 'Premium',
    amount: 49.00,
    method: 'stripe',
    status: 'paid',
    reviewed: true,
    date: '2026-06-03',
    reference: 'PAY-20260603-006',
    customerEmail: 'admin@urbana101.com',
    description: 'Suscripción mensual Premium — Junio 2026',
    invoiceId: 'INV-202606-006',
    contractId: 'CTR-2026-006',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'API Dedicada'],
    processor: 'Stripe Connect',
  },
  {
    id: 7,
    radioName: 'Radio Éxitos TV',
    frequency: '100.00 RFW',
    planName: 'Business',
    amount: 39.00,
    method: 'paypal',
    status: 'paid',
    reviewed: false,
    date: '2026-06-04',
    reference: 'PAY-20260604-007',
    customerEmail: 'admin@exitostv.com',
    description: 'Suscripción mensual Business — Junio 2026',
    invoiceId: 'INV-202606-007',
    contractId: 'CTR-2026-007',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'Soporte VIP 24/7'],
    processor: 'PayPal Business',
  },
  {
    id: 8,
    radioName: 'Radio Folclor Andino',
    frequency: '107.90 RFW',
    planName: 'Básico',
    amount: 9.00,
    method: 'manual',
    status: 'pending',
    reviewed: false,
    date: '2026-06-05',
    reference: 'PAY-20260605-008',
    customerEmail: 'admin@folclorandino.com',
    description: 'Suscripción mensual Básico — Junio 2026 — Pago en efectivo pendiente de verificación',
    contractId: 'CTR-2026-008',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: [],
    processor: 'Procesador Manual',
  },
  {
    id: 9,
    radioName: 'Jazz Club Radio',
    frequency: '92.80 RFW',
    planName: 'Pro',
    amount: 19.00,
    method: 'stripe',
    status: 'failed',
    reviewed: false,
    date: '2026-06-05',
    reference: 'PAY-20260605-009',
    customerEmail: 'admin@jazzclub.com',
    description: 'Suscripción mensual Pro — Junio 2026 — Tarjeta rechazada por fondos insuficientes',
    invoiceId: 'INV-202606-009',
    contractId: 'CTR-2026-009',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium'],
    processor: 'Stripe Connect',
  },
  {
    id: 10,
    radioName: 'Radio Marítima',
    frequency: '89.50 RFW',
    planName: 'Starter',
    amount: 0.00,
    method: 'stripe',
    status: 'paid',
    reviewed: true,
    date: '2026-06-01',
    reference: 'PAY-20260601-010',
    customerEmail: 'admin@maritima.com',
    description: 'Verificación de tarjeta — Plan Starter gratuito',
    contractId: 'CTR-2026-010',
    extras: [],
    processor: 'Stripe Connect',
  },
  {
    id: 11,
    radioName: 'Radio Sonora Digital',
    frequency: '96.20 RFW',
    planName: 'Starter',
    amount: 0.00,
    method: 'manual',
    status: 'manual_review',
    reviewed: false,
    date: '2026-06-06',
    reference: 'PAY-20260606-011',
    customerEmail: 'admin@sonoradigital.com',
    description: 'Pago con cheque N° 4512 — En proceso de verificación bancaria',
    contractId: 'CTR-2026-011',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: [],
    processor: 'Procesador Manual',
  },
  {
    id: 12,
    radioName: 'Clásica FM',
    frequency: '99.10 RFW',
    planName: 'Básico',
    amount: 12.00,
    method: 'paypal',
    status: 'refunded',
    reviewed: true,
    date: '2026-05-28',
    reference: 'PAY-20260528-012',
    customerEmail: 'admin@clasicafm.com',
    description: 'Suscripción mensual Básico — Mayo 2026 — Reembolsado por cierre de emisora',
    invoiceId: 'INV-202605-012',
    contractId: 'CTR-2026-012',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium'],
    processor: 'PayPal Business',
  },
  {
    id: 13,
    radioName: 'Radio Retro Hits',
    frequency: '93.10 RFW',
    planName: 'Premium',
    amount: 49.00,
    method: 'stripe',
    status: 'failed',
    reviewed: false,
    date: '2026-06-07',
    reference: 'PAY-20260607-013',
    customerEmail: 'admin@retrohits.com',
    description: 'Suscripción mensual Premium — Junio 2026 — Fondos insuficientes. Se intentó 3 veces.',
    invoiceId: 'INV-202606-013',
    contractId: 'CTR-2026-013',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'App Móvil', 'CDN Premium', 'Soporte VIP 24/7'],
    processor: 'Stripe Connect',
  },
  {
    id: 14,
    radioName: 'Radio Vibra FM',
    frequency: '90.80 RFW',
    planName: 'Business',
    amount: 39.00,
    method: 'stripe',
    status: 'pending',
    reviewed: false,
    date: '2026-06-08',
    reference: 'PAY-20260608-014',
    customerEmail: 'admin@vibrafm.com',
    description: 'Suscripción mensual Business — Junio 2026 — En proceso de confirmación',
    invoiceId: 'INV-202606-014',
    contractId: 'CTR-2026-014',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'API Dedicada'],
    processor: 'Stripe Connect',
  },
  {
    id: 15,
    radioName: 'Radio Fusión Latina',
    frequency: '105.30 RFW',
    planName: 'Básico',
    amount: 9.00,
    method: 'manual',
    status: 'pending',
    reviewed: false,
    date: '2026-06-09',
    reference: 'PAY-20260609-015',
    customerEmail: 'admin@fusionlatina.com',
    description: 'Suscripción mensual Básico — Junio 2026 — Transferencia bancaria en verificación',
    contractId: 'CTR-2026-015',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: [],
    processor: 'Procesador Manual',
  },
  {
    id: 16,
    radioName: 'Radio Horizonte Digital',
    frequency: '102.10 RFW',
    planName: 'Pro',
    amount: 19.00,
    method: 'manual',
    status: 'cancelled',
    reviewed: true,
    date: '2026-06-06',
    reference: 'PAY-20260606-016',
    customerEmail: 'admin@horizontedigital.com',
    description: 'Suscripción mensual Pro — Cancelada por la emisora antes del cobro',
    contractId: 'CTR-2026-016',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['App Móvil'],
    processor: 'Procesador Manual',
  },
  {
    id: 17,
    radioName: 'Radio Sinfonía Web',
    frequency: '95.40 RFW',
    planName: 'Business',
    amount: 39.00,
    method: 'manual',
    status: 'manual_review',
    reviewed: false,
    date: '2026-06-09',
    reference: 'PAY-20260609-017',
    customerEmail: 'admin@sinfoniaweb.com',
    description: 'Pago en efectivo recibido en oficina — Pendiente de registro contable',
    contractId: 'CTR-2026-017',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'CDN Premium'],
    processor: 'Procesador Manual',
  },
  {
    id: 18,
    radioName: 'Radio Cumbia Total',
    frequency: '86.70 RFW',
    planName: 'Premium',
    amount: 49.00,
    method: 'manual',
    status: 'refunded',
    reviewed: true,
    date: '2026-05-15',
    reference: 'PAY-20260515-018',
    customerEmail: 'admin@cumbiatotal.com',
    description: 'Suscripción mensual Premium — Mayo 2026 — Reembolsado: cheque sin fondos',
    invoiceId: 'INV-202605-018',
    contractId: 'CTR-2026-018',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'App Móvil', 'Soporte VIP 24/7'],
    processor: 'Procesador Manual',
  },
  {
    id: 19,
    radioName: 'Radio Fiesta Tropical',
    frequency: '104.80 RFW',
    planName: 'Pro',
    amount: 19.00,
    method: 'square',
    status: 'paid',
    reviewed: false,
    date: '2026-06-10',
    reference: 'PAY-20260610-019',
    customerEmail: 'admin@fiestatropical.com',
    description: 'Suscripción mensual Pro — Junio 2026',
    invoiceId: 'INV-202606-019',
    contractId: 'CTR-2026-019',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['App Móvil', 'CDN Premium'],
    processor: 'Square POS',
  },
  {
    id: 20,
    radioName: 'Radio Concierto Digital',
    frequency: '97.30 RFW',
    planName: 'Business',
    amount: 39.00,
    method: 'manual',
    status: 'paid',
    reviewed: true,
    date: '2026-06-10',
    reference: 'PAY-20260610-020',
    customerEmail: 'admin@conciertodigital.com',
    description: 'Suscripción mensual Business — Junio 2026 — Transferencia bancaria confirmada',
    invoiceId: 'INV-202606-020',
    contractId: 'CTR-2026-020',
    annualLicense: 'Licencia Anual de Frecuencia RFW — $49.95',
    extras: ['Dominio Premium', 'App Móvil', 'CDN Premium', 'API Dedicada'],
    processor: 'Procesador Manual',
  },
];